import { BRAND, CURRENT_SPORT } from '../lib/brand';

export const Brand = ({ small = false }) => {
  const id = small ? 'brand-mark' : 'brand-logo';
  return (
    <div className={`brand shc-brand${small ? ' brand-small' : ''}`} data-testid={id}>
      <img
        className="brand-wordmark"
        data-testid={`${id}-image`}
        src={BRAND.wordmark}
        alt={BRAND.name}
        fetchPriority="high"
        decoding="async"
      />
    </div>
  );
};

export const SportLabel = ({ id, className = '' }) => (
  <span className={`sport-label ${className}`} data-testid={id}>
    <span className="sport-label-dot" aria-hidden="true" />
    {CURRENT_SPORT.name}
  </span>
);